var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoaded)?_c('SuccessfulBookingWithNoPaymentNoPost',{attrs:{"additions":_vm.additions,"owner":_vm.owner,"customers":_vm.customers,"destination-package":_vm.destinationPackage,"order":_vm.order,"order-total-price":_vm.orderTotalPrice,"product-details":_vm.productDetails}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }